// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__s9rCL","content":"styles_content__3tb1V","selectAll":"styles_selectAll__CYuOs"};